<template>
  <router-link
    :to="'/news-feed/'+cluster.id+'/articles'"
    class="group relative flex items-center justify-center px-6 py-16"
  >
    <img
      :src="'/storage/'+cluster.image_url"
      class="rounded-3xl absolute inset-0 object-cover w-full h-full overflow-hidden"
    >

    <div
      class="group-hover:opacity-40 rounded-3xl opacity-60 absolute inset-0 w-full h-full duration-200"
      :class="{'bg-primary-900': cluster.image_only == false}"
    />

    <div class="relative text-center">
      <h2
        v-if="cluster.image_only == false"
        class="text-xl font-semibold leading-tight text-white"
      >
        {{ cluster.title }}
      </h2>

      <div class="-bottom-20 relative">
        <v-add-to-favorite
          v-if="!clusterIsInFavorite"
          :cluster="cluster"
          @success="fetch()"
        />
        <v-remove-from-favorite
          v-else
          :cluster="cluster"
          @success="fetch()"
        />
      </div>
    </div>
  </router-link>
</template>

<script>
import addToFavorite from "./actions/addToFavorite.vue";
import removeFromFavorite from "./actions/removeFromFavorite.vue";

export default {
  components: {
    "v-add-to-favorite": addToFavorite,
    "v-remove-from-favorite": removeFromFavorite
  },
  props: {
    cluster: {
      required: true,
      type: Object,
    }
  },
  emits: ["fetch"],
  computed: {
    clusterIsInFavorite() {
      let usersIds = this.cluster.users.map(
        (user) => {
          return user.id;
        }
      );

      return usersIds.includes(this.$laravel.user.id);
    }
  },
  methods: {
    fetch () {
      this.$emit("fetch");
    }
  }
};
</script>

<style>

</style>
